import { sortExternalLinks } from './util'
import { externalLinkListKey } from '../keys'
import { type ExternalLinkData, type ExternalLinkListInput, type ExternalLinkListSuccess } from '@terros/common'
import { useTantalimQuery } from '../query'
import { type GetHookResponse } from '../hooks'

export function useExternalLinks(input: ExternalLinkListInput): GetHookResponse<ExternalLinkData[]> {
  return useTantalimQuery<ExternalLinkListInput, ExternalLinkListSuccess, ExternalLinkData[]>({
    url: '/externalLink/list',
    queryKey: externalLinkListKey(input),
    input,
    convertResponse: (data) => {
      return sortExternalLinks(data.externalLinks)
    },
  })
}
